import { getDocFromServer, type DocumentReference } from 'firebase/firestore';
import { VersionedDoc, readDocVersion } from './versionedDoc';

/**
 * A VersionedDoc for one Firestore document. After a refusal it reads the
 * stored version from the SERVER, never the local cache: the question is
 * whether someone else wrote, and only the server knows.
 */
export function versionedDocFor(ref: DocumentReference, markerOf?: (data: unknown) => string | undefined): VersionedDoc {
  return new VersionedDoc(
    async () => readDocVersion((await getDocFromServer(ref)).data()),
    markerOf ? async () => markerOf((await getDocFromServer(ref)).data()) : undefined,
  );
}
